import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class QuotationService {
    count = 0;
    //: string;
    //productDescription: string;
    //productAmount: number;
    productObjDetails : any;
    productDetails: string[] = [];
    total : number = 0;

    constructor() {}

    onAddProductForm(productName, productDesc, productAmt: HTMLInputElement) {
        this.productObjDetails = {
            productName: productName,
            productDescription: productDesc,
            productAmount: Number(productAmt)
        }
        this.onTotal();
    }
   
    onTotal(){
      return this.total = this.total+this.productObjDetails.productAmount;
     } 
}
